import React from "react";
import { Card, Row, Col, CardTitle, CardBody, CardFooter, Button, UncontrolledTooltip } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";

const ReponseCard = ({
  title,
  onChange,
  onChangeText,
  handleReponseSubmit,
}) => {
  return (
    <div className="p-3 chat-input-section">
                        <Row>
                          <Col>
                            <div className="position-relative">
                              <textarea
                                type="message"
                                onChange={onChangeText}
                                className="form-control "
                                rows="6"
                                placeholder="Entrer votre message..."
                              />
                            </div>
                          </Col>
                          <Col className="col-auto">
                            <Button
                              type="button"
                              color="primary"
                              onClick={handleReponseSubmit}
                              className="btn btn-primary btn-rounded chat-send w-md "
                            >
                              <span className="d-none d-sm-inline-block me-2">
                                Envoyer
                              </span>{" "}
                              <i className="mdi mdi-send" />
                            </Button>
                          </Col>
                        </Row>
                        <br></br>
                        <Row>
                          <input
                            type="file"
                            className="form-control-file"
                            onChange={onChange}
                          />
                        </Row>
                      </div>
  );
};

export default ReponseCard;
